import React, { useEffect, useState } from "react";
import { AiDisclaimer } from "../components/AiDisclaimer";
import { useNavigate } from "react-router-dom";
import { Nav } from "../components/Nav";
import { useLang } from "../i18n";
import { api } from "../api";
import { ArrowLeft, ShieldPlus, ArrowUpRight, ChevronDown, Stethoscope } from "lucide-react";

export default function Protocols() {
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const [protocols, setProtocols] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    api.get(`/protocols?lang=${lang}`).then((r) => setProtocols(r.data.protocols || [])).catch(() => {});
  }, [lang]);

  return (
    <div className="App min-h-screen">
      <Nav />
      <div className="max-w-3xl mx-auto px-6 py-10">
        <button onClick={() => navigate("/dashboard")} className="flex items-center gap-2 text-[#6E6B65] mb-4 hover:text-[#3F6E85]" data-testid="protocols-back">
          <ArrowLeft className="w-4 h-4" /> {t("back")}
        </button>
        <div className="flex items-center gap-3 mb-2">
          <span className="w-10 h-10 rounded-full bg-[#EAF0EC] flex items-center justify-center"><ShieldPlus className="w-5 h-5 text-[#3B604E]" /></span>
          <h1 className="font-serif text-4xl sm:text-5xl tracking-tight">{t("protocols_title")}</h1>
        </div>
        <p className="text-[#6E6B65] mb-4 max-w-xl">{t("protocols_sub")}</p>
        <p className="text-[11px] text-[#6E6B65] mb-8 max-w-xl" data-testid="protocols-disclaimer">{t("protocols_disclaimer")}</p>

        <div className="space-y-3" data-testid="protocols-list">
          {protocols.map((p) => {
            const isOpen = open === p.key;
            return (
              <div key={p.key} className="rounded-2xl border border-stone-200 bg-white overflow-hidden" data-testid={`protocol-${p.key}`}>
                <button onClick={() => setOpen(isOpen ? null : p.key)} data-testid={`protocol-toggle-${p.key}`}
                  className="w-full flex items-center justify-between gap-3 px-5 py-4 hover:bg-[#F3F1ED] transition-colors text-left">
                  <span className="font-semibold text-[#2B4A59]">{p.name}</span>
                  <ChevronDown className={`w-4 h-4 text-[#6E6B65] transition-transform ${isOpen ? "rotate-180" : ""}`} />
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 border-t border-stone-100" data-testid={`protocol-content-${p.key}`}>
                    <ul className="space-y-2 mt-4 mb-5">
                      {p.guidance.map((g, i) => (
                        <li key={i} className="flex gap-2 text-sm text-[#3a3a3a]">
                          <span className="text-[#3B604E] mt-0.5">›</span> {g}
                        </li>
                      ))}
                    </ul>
                    <a href={p.specialist_url} target="_blank" rel="noopener noreferrer" data-testid={`protocol-specialist-${p.key}`}
                      className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold bg-[#C81D6B] hover:bg-[#b0175d] text-white transition-colors">
                      <Stethoscope className="w-4 h-4" /> {t("book_specialist")} <ArrowUpRight className="w-4 h-4" />
                    </a>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <AiDisclaimer />
      </div>
    </div>
  );
}
